import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from '../../../baseClasses/BaseComponent';
import ProjectFilterPopout from '../../../components/ProjectFilterPopout';
import './ProjectSearchFilter.scss';
import Input from '../../Input';

export default class ProjectSearchFilter extends BaseComponent {

  constructor(props) {
    super(props);

    ProjectSearchFilter.propTypes = {
      handleSearchChange: PropTypes.func,
      handleFilterChange: PropTypes.func,
      selectedFilters: PropTypes.object,
    };

    this.state = { search: this.props.search || '' };
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps) {
    if (prevProps.search != this.props.search) {
      this.handleSearchChange({ target: { value: this.props.search } });
    }
    if (prevProps.resetSearchString != this.props.resetSearchString) {
      this.setState({ search: '' });
    }
  }

  handleKeyDown(e) {
    if (e.keyCode == 13 || e.keyCode == 40) {
      this.handleAddProject();
    }
    else if (e.keyCode == 27) {
      this.handleCancel();
    }
  }

  handleFilterClick(){
    this.setState({ showFilterPopout: true });
  }

  handlePopoutClose(){
    this.setState({ showFilterPopout: false });
  }
  
  handleSearchChange(e) {
    this.setState({ search: e.target.value });
    if (this.props.handleSearchChange) {
      this.props.handleSearchChange(e.target.value);
    }
  }

  handleApplyFilter(filter){
    if (filter && (filter.state || filter.project_type || filter.showArchived || filter.statuses || filter.markets)){
      if (this.props.handleFilterChange) {
        this.props.handleFilterChange(filter);
      }
    }
    else {
      this.handleFilterClear();
    }
  }

  handleFilterClear(){
    if (this.props.handleFilterChange) {
      this.props.handleFilterChange(null);
    }
  }

  render() {
    let filterPopout = null;
    if(this.state.showFilterPopout && !this.props.hideFilter){
      let rect; 
      let leftPos = 500;
      if(this.filterRoot){
        rect = this.filterRoot.getBoundingClientRect();
        let parent = this.filterRoot.parentElement.parentElement;
        let parentRect = parent.getBoundingClientRect();
        leftPos = rect.left - parentRect.left + rect.width + 10;
      }

      filterPopout = <ProjectFilterPopout key="project-search-filter"
          top={rect ? rect.height / 2 - 20 : 63} 
          left={leftPos}
          displayFontStyle={{ fontSize: '12px', fontFamily: 'Open Sans', color: '#000000', lineHeight: '32px' }}
          handleCancel={this.handlePopoutClose}
          handleClear={this.handleFilterClear}
          handleApplyFilter={this.handleApplyFilter}
          selectedFilters={this.props.selectedFilters}
          archivedDisabled={this.props.archivedDisabled}
          isMarketFilterEnabled={this.props.isMarketFilterEnabled}
          />;
    }

    let filterApplied = null;
    if(this.props.selectedFilters){
      filterApplied = <div className={'filter-applied' + (this.props.fromPOR ? ' less-right' : '')}></div>;
    }

    let classes = '';
    if(this.props.locationsProjects){
      classes += ' locations-projects';
    }
    if(this.props.adjustBottom){
      classes += ' adjust-bottom-margin';
    }

    return (
        <div className={'search-box' + classes}>
        <Input className='search-input' name="search_projects_sidebar" type="text" value={this.state.search}
          placeholder={this.props.overridePlaceHolder ? this.props.overridePlaceHolder : this.textMap.searchProject} onChange={this.handleSearchChange} />
        <div className="search-icon" />
        {!this.props.hideFilter &&
          <div className='filter-box' onClick={this.handleFilterClick}>
            <div className="filter-icon" ref={ element => {this.filterRoot = element;}}  />
            {filterApplied}
          </div>
          }
          {filterPopout}
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProjectsNav/ProjectSearchFilter/index.js